import NothingFoundBlock from './NothingFoundBlock';

export default NothingFoundBlock;
